<textarea class="input w-full max-w-lg h-[100px]" [(ngModel)]="value" name="message" id="message" (ngModelChange)="onInput($event)"></textarea>

